import React from "react";
import { Table } from "dyl-components";
import { Loader, Segment, Pagination, Header } from "semantic-ui-react";
import PermissionsRow from "./PermissionsRow";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import rolesActions from "actions/roles";

const PermissionsTable = ({ permissionProfile }) => {
    const dispatch = useDispatch();
    const { count, isReadingRoles } = useSelector((state) => state.roles);
    const [query] = useSearchParams();
    const search = query.get("search") || "";
    const page = query.get("page") || 1;
    const limit = 25;

    const navigate = useNavigate();

    const onChangePage = (_, { activePage }) => {
        query.set("page", activePage);
        let searchParams = new URLSearchParams({
            page: activePage,
            ...(search ? { search } : {}),
        }).toString();
        dispatch(rolesActions.readRoles({ page: activePage, limit, search }));
        navigate(`/settings/permission-profile?${searchParams}`);
    };

    if (isReadingRoles) {
        return (
            <Segment>
                <Loader active />
            </Segment>
        );
    }

    return (
        <React.Fragment>
            <Table>
                <Table.Header primary>
                    <Table.Row>
                        <Table.HeaderCell width="1" style={{ padding: 15 }}>
                            Permission Profile
                        </Table.HeaderCell>
                        <Table.HeaderCell style={{ padding: 15 }}>
                            Assigned Users
                        </Table.HeaderCell>
                        <Table.HeaderCell width="1" style={{ padding: 15 }}>
                            Actions
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {permissionProfile.map((permission) => (
                        <PermissionsRow
                            key={permission.id}
                            permission={permission}
                        />
                    ))}
                </Table.Body>
            </Table>
            {permissionProfile.length === 0 ? (
                <Header as="h3">No Results Found</Header>
            ) : (
                <div className="Pagination">
                    <Pagination
                        boundaryRange={0}
                        activePage={page}
                        ellipsisItem={null}
                        siblingRange={2}
                        totalPages={Math.ceil(count / limit)}
                        onPageChange={onChangePage}
                    />
                </div>
            )}
        </React.Fragment>
    );
};

export default PermissionsTable;
